const ReportTemplateReformatCopyData = (listRawData) => {
  if (!listRawData) return [];

  return listRawData.map((rawData) => {
    return {
      "Nomor Polisi": rawData.data_kendaraan?.nomor_polisi ?? "-",
      "Jenis Mobil": rawData.data_kendaraan?.jenis_mobil ?? "-",
      "Tanggal": rawData.tanggal_transaksi
        ? new Date(rawData.tanggal_transaksi).toLocaleString("id-ID", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
        : "-",
      "Service": rawData.data_service?.nama ?? "-",
      "Speedo Akhir": rawData.speedo_akhir ?? "-",
      "Keterangan": rawData.keterangan ?? "-",
    };
  });
};

export default ReportTemplateReformatCopyData;
